// ————————————————————————————————————————————— LIB. ————————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

// Event Handlers //
import {
  hdl_global_mouseMove,
  hdl_header_mouseEnter,
  hdl_header_mouseLeave,
  hdl_document_mouseLeave,
} from "../eventHandlers/hdl_previewAnimation.js";
import { hdl_header_click } from "../eventHandlers/hdl_itemToggle.js";

// ———————————————————————————————————————————— UTIL. ————————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

// ...

// ———————————————————————————————————————— EVENT HANDLERS ———————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

// ...

// ———————————————————————————————————————————— ASSETS ———————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

const logArgs = { eventName: "init_items", inline: true, disabled: false };
const msgs = {
  start: ["init. items"],
  end: ["init. items", "init. success"],
  no_el: ["init. items", "no valid DOM el. provided"],
};

// —————————————————————————————————————— INIT. METHOD DEF. ——————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

export default function init_items() {
  //////////////////////////////////////////// Setup /////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////

  const { items } = this.ref;
  const id_comp = this.element.id;
  this.logger("init", msgs.start, "action", logArgs);
  if (items === undefined) return this.cancel_featInit(msgs.no_el);
  if (items.every((el) => !this.validate_refEl(el))) return this.cancel_featInit(msgs.no_el);

  //////////////////////////////////////////// ACTION ////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////

  // Add global mouse move listener for smooth preview portraits following
  document.addEventListener("mousemove", hdl_global_mouseMove);

  // Add global mouseleave listener to catch edge cases
  document.addEventListener("mouseleave", hdl_document_mouseLeave);

  // Item initialization //
  items.forEach((it) => {
    // Setup //
    const header = it.querySelector('[data-ref="header"]');
    const wrpr_content = it.querySelector('[data-ref="wrpr_content"]');

    if (header) {
      // Add click handler for toggle functionality
      if (wrpr_content) header.addEventListener("click", hdl_header_click);

      // Add mouse event listeners for preview portraits animation on HEADER element
      header.addEventListener("mouseenter", (e) => hdl_header_mouseEnter(e, id_comp));
      header.addEventListener("mouseleave", (e) => hdl_header_mouseLeave(e, id_comp));
    }
  });

  /////////////////////////////////////////// Conclude ///////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////

  this.logger("init", msgs.end, "success", logArgs);
}

// ———————————————————————————————————————————————————————————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //
